import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackSectionVisit } from "@/utils/sectionTracker";

/**
 * Custom hook to track section visits
 * Add this to any page component to automatically track visits
 */
export const useTrackSection = () => {
  const location = useLocation();

  useEffect(() => {
    // Track section visit when component mounts or path changes
    trackSectionVisit(location.pathname);
  }, [location.pathname]);
};

export default useTrackSection;
